import React, { Fragment, FC } from 'react';

import { Message2Icon } from '@zola/zola-ui/src/components/SvgIconsV3/Message2';
import { useGladlyChat } from '@zola/zola-ui/src/hooks/useGladlyChat';

import { Global } from '@emotion/react';

import featureFlags from '~/util/featureFlags';

import { GladlyStyles, GladlyButton, UnreadDot } from './VendorGladApp.styles';

const ZolaGladApp: FC = () => {
  useGladlyChat({
    isChatEnabled: featureFlags.get('enableVendorGladlyChat'),
    appId: 'zola.com-vendor-chat',
  });

  return (
    <Fragment>
      <Global styles={GladlyStyles} />
      <GladlyButton type="button" id="custom-gladly-chat-button">
        <Message2Icon width={24} height={24} />
        <UnreadDot id="with-unread-message" />
      </GladlyButton>
    </Fragment>
  );
};

export default ZolaGladApp;
